import styled from 'styled-components';

export const StyledChatPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85vh;
  width: 100vw;
  font-size: 25px;
`;
